import React, { useEffect, useState } from "react";
import { usePricing } from "../hooks/contexts/pricing-hooks";
import ErrorModal from "./Modals/ErrorModal";
import { useOffers } from "../hooks/contexts/offers-hook";
import { CircularProgress } from "@material-ui/core";

/**
 * This function/component creates the pricing table for TPO loan comparison.
 * This uses the usePricing provider to retrieve pricing data based on current offer
 * @callback handleRadioChangeCallback
 * @param {handleRadioChangeCallback} handleRadioChange Callback to update radio button
 * @returns {React.JSX.Element}
 */
export default function PricingTable({ 
  handleRadioChange, 
  pricingPayload, 
  getPricingDTO, 
  useBattery, 
  loan, 
  selectedEscRate, }) {
  const { pricing, errorMessage, isLoading, getPricing } = usePricing();
  const { offer } = useOffers();
  const [selectedPpa, setSelectedPpa] = useState(loan.offerId === offer.id ? loan.ppaRate : -1);
  useEffect(() => console.log("Loading Pricing"), [isLoading]);

  useEffect(() => {
    getPricing(pricingPayload, getPricingDTO);
  }, [, pricingPayload]);

   useEffect(() => console.log("Pricing", pricing), [pricing]);

  const setChecked = (price) => {
    if (price && 
        price.productionRate.value === selectedPpa &&
          (+(loan.ppaEscalator * 100).toFixed(4) === selectedEscRate)) {
        handleRadioChange(price);
        return true;
      }
  }

  const mappedPricing = pricing.map((price, i) => {
    // if (price.pricePerUnit.price >= 2.4)
    // {
      return (
        <tr key={i}>
          <td>
            <input
              type="radio"
              id={`pricing-${i}`}
              name="pricingOpts"
              value={i}
              checked={setChecked(price)}
              onChange={(e) => {
                setSelectedPpa(price.productionRate.value);
                handleRadioChange(price); 
              }} />
            <label htmlFor={`pricing-${i}`}></label>
          </td>
          <td className="qualyText" scope="row">
            ${(price.productionRate.value).toFixed(3)}
          </td>
          <td className="qualyText" scope="row">
            ${(price.firstYearMonthlyPayment.value)}
          </td>
          {useBattery && 
            <>
            <td className="qualyText" scope="row">
              ${price.firstYearMonthlyBattery.value ? price.firstYearMonthlyBattery.value : 0}
            </td>
            <td className="qualyText" scope="row">
              ${((price.firstYearMonthlyBattery.value ? price.firstYearMonthlyBattery.value : 0) + price.firstYearMonthlyPayment.value).toFixed(2)}
            </td>
            </>}
          <td className="qualyText" scope="row">
            {offer.term} YR
          </td>
          <td className="qualyText" scope="row">
            ${Number(price.purchasePrice.value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          </td>
          <td className="qualyText" scope="row">
            ${(price.pricePerUnit.price).toPrecision(3)}
          </td>
        </tr>
      );
    }
  );

  return errorMessage ?
    <ErrorModal
      errorMessage={errorMessage} />
    : mappedPricing.length > 0 ? (
      <>
      <table className="table table-striped table-borderless">
        <thead>
          <tr className="table-borderless">
            <th className="qualyText" scope="col"></th>
            <th className="qualyText" scope="col">
              $ / kWh
            </th>
            <th className="qualyText" scope="col">
              Monthly Payment
            </th>
            {useBattery && 
              <>
              <th className="qualyText" scope="col">
                Monthly Batt. Cost
              </th>
              <th className="qualyText" scope="col">
                Total Monthly Payment
              </th>
              </>}
            <th className="qualyText" scope="col">
              Term
            </th>
            <th className="qualyText" scope="col">
              Purchase Price
            </th>
            <th className="qualyText" scope="col">
              PPW
            </th>
          </tr>
        </thead>
        <tbody>
          {mappedPricing}
        </tbody>
      </table>
    </>
    ) : isLoading ?
      <div>
        <CircularProgress size={50} color="inherit" variant="indeterminate" />
      </div>
      : <p>No Pricing Options found</p>
}